import {Component, Input, OnInit} from '@angular/core';
import {DeviceDetectorService} from "ngx-device-detector";
import {GlobalConstantsComponent} from '../../shared/global-constants/global-constants.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgIf, NgClass, NgFor } from '@angular/common';

@Component({
  selector: 'app-faq-accordion',
  templateUrl: './faq-accordion.component.html',
  styleUrls: ['./faq-accordion.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, MatExpansionModule, NgFor, TranslateModule]
})
export class FaqAccordionComponent implements OnInit {

    @Input() faqFields;
    @Input() classes;
    @Input() firstExpanded = false;

    private mediaPath = GlobalConstantsComponent.mediaURL + 'faq/icons/';
    panelOpen;
    isMobile = false;

  constructor(
    private mobileDetector: DeviceDetectorService,
  ) { }

  ngOnInit(): void {
    this.isMobile = this.mobileDetector.isMobile();
    if (this.firstExpanded) {
      this.panelOpen = 0
    }
  }

  changeIcon(index: number) {
    if (index === this.panelOpen) {
      this.panelOpen = null;
    } else {
      this.panelOpen = index;
    }
  }

  public checkUrl(url) {
    if (url.startsWith('http') || url.startsWith('assets')) return url;
    return this.mediaPath+url;
  }
}
